import SourceProductPage from 'SourceRoute/ProductPage/ProductPage.component';
import ProductInformation from 'Component/ProductInformation';
import ContentWrapper from 'Component/ContentWrapper';
import ProductGallery from 'Component/ProductGallery';
import ProductActions from 'Component/ProductActions';
import BuyTogether from 'Component/BuyTogether';
import Event, { EVENT_GTM_PRODUCT_DETAIL } from 'Util/Event';

export class ProductPage extends SourceProductPage {
    componentDidMount() {
        const { areDetailsLoaded } = this.props;

        if (areDetailsLoaded) {
            this._gtmProductDetail();
        }
    }

    componentDidUpdate(prevProps) {
        const { areDetailsLoaded, location: { pathname, search } } = this.props;
        const { areDetailsLoaded: prevAreDetailsLoaded, location: { pathname: prevPathname , search: prevSearch} } = prevProps;

        if (
            (areDetailsLoaded && areDetailsLoaded !== prevAreDetailsLoaded)
            || (areDetailsLoaded && `${pathname}${search}` !== `${prevPathname}${prevSearch}`)
        ) {
            this._gtmProductDetail();
        }
    }

    _gtmProductDetail() {
        const { product, location: { pathname, search }, configurableVariantIndex } = this.props;
        if (product && product.price_range && product.attributes) {
            Event.dispatch(EVENT_GTM_PRODUCT_DETAIL, {
                product: { ...product, configurableVariantIndex },
                pathname: `${pathname}${search}`
            });
        }
    }

    renderProductPageContent() {
        const {
            configurableVariantIndex,
            parameters,
            getLink,
            dataSource,
            updateConfigurableVariant,
            productOrVariant,
            areDetailsLoaded,
            getSelectedCustomizableOptions,
            productOptionsData,
            setBundlePrice,
            selectedBundlePrice
        } = this.props;

        const {
            attributes: {
                sticker_info: {
                    attribute_options: attribute_options_info
                } = {},
                sticker_promo: {
                    attribute_options: attribute_options_promo
                } = {},
                sticker_promo_account: {
                    attribute_options: attribute_options_promo_account
                } = {}
            } = {}
        } = dataSource;

        return (
            <>
                <ProductGallery
                  product={ productOrVariant }
                  stickersValues={[attribute_options_info, attribute_options_promo, attribute_options_promo_account]}
                  areDetailsLoaded={ areDetailsLoaded }
                />
                <ProductActions
                  getLink={ getLink }
                  updateConfigurableVariant={ updateConfigurableVariant }
                  product={ dataSource }
                  productOrVariant={ productOrVariant }
                  parameters={ parameters }
                  areDetailsLoaded={ areDetailsLoaded }
                  configurableVariantIndex={ configurableVariantIndex }
                  getSelectedCustomizableOptions={ getSelectedCustomizableOptions }
                  productOptionsData={ productOptionsData }
                  setBundlePrice={ setBundlePrice }
                  selectedBundlePrice={ selectedBundlePrice }
                />
            </>
        );
    }

    renderBuyTogether() {
        return <BuyTogether />;
    }

    renderAdditionalSections() {
        const {
            dataSource,
            parameters,
            areDetailsLoaded
        } = this.props;

        return (
            <ProductInformation
              product={ { ...dataSource, parameters } }
              areDetailsLoaded={ areDetailsLoaded }
            />
        );
    }

    render() {
        return (
            <main
              block="ProductPage"
              aria-label="Product page"
              itemScope
              itemType="http://schema.org/Product"
            >
                <ContentWrapper
                  mix={{ block: 'ProductPage', elem: 'Top' }}
                  wrapperMix={ { block: 'ProductPage', elem: 'Wrapper' } }
                  label={ __('Main product details') }
                >
                    { this.renderProductPageContent() }
                </ContentWrapper>
                { this.renderBuyTogether() }
                { this.renderAdditionalSections() }
            </main>
        );
    }
}

export default ProductPage;
